import { AdminSessionsPage } from '@/pages/admin/admin-sessions-page'

export function TrainerSessionsPage() {
  return <AdminSessionsPage mode="trainer" />
}
